/**
 * @license
 * Copyright Endlessjs. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

import { NgModule } from '@angular/core';
import { ElSharedModule } from '../shared/shared.module';
import { ElInputDirective } from './input.directive';

const EL_INPUT_COMPONENTS = [
  ElInputDirective,
];

@NgModule({
  imports: [ ElSharedModule ],
  declarations: EL_INPUT_COMPONENTS,
  exports: EL_INPUT_COMPONENTS,
})
export class ElInputModule {}
